import React from 'react';
import { Users, MessageSquare, TrendingUp } from 'lucide-react';

export const MOCK_DATA = {
  benefits: [
    {
      icon: <Users className="w-8 h-8 text-white" />,
      title: 'Wir setzen deinen AI-Agent auf',
      description: 'Als Agentur übernehmen wir das komplette Setup. Wir trainieren den AI-Agent mit deinen Firmendaten, Produktinfos und deinem individuellen Kommunikationsstil.'
    },
    {
      icon: <MessageSquare className="w-8 h-8 text-white" />,
      title: 'LinkedIn-Experten prüfen jede Nachricht',
      description: 'Der AI-Agent formuliert vor – unsere erfahrenen LinkedIn-Experten überprüfen jede Nachricht. Diese Kombination sorgt für über 60% Rückmelderate.'
    },
    {
      icon: <TrendingUp className="w-8 h-8 text-white" />,
      title: 'Wird kontinuierlich besser',
      description: 'Mit jedem Feedback lernt der AI-Agent dazu und trifft deinen Ton immer präziser. Du investierst nur 30 Minuten pro Monat – wir erledigen den Rest.'
    }
  ],

  stats: [
    { value: '500+', label: 'Erfolgreiche Kunden' },
    { value: '60%+', label: 'Rückmelderate' },
    { value: '1.000+', label: 'Interaktionen/Monat' },
    { value: '24M', label: 'LinkedIn Nutzer DACH' }
  ],

  testimonials: [
    {
      name: 'Jochen Prinz',
      position: 'Geschäftsführer',
      company: 'Ventatio GmbH',
      text: 'Hier sind Experten für LinkedIn am Start! Die Zusammenarbeit mit Euch ist klasse und macht viel Spaß. Sehr kompetent und zuverlässig! Es wurde klar kommuniziert, dass man als Kunde auch seinen Input zum Erfolg der Kampagnen beizutragen hat. Sehr viel gelernt und sehr hochwertige Kontakte geknüpft.'
    },
    {
      name: 'Peter Gorini',
      position: 'Founder & CSO',
      company: 'Aureum Partners AG',
      text: 'Die Zusammenarbeit ist zu jeder Zeit professionell. Katharina reagiert flexibel und schnell auf Rückmeldungen von mir und passt die Strategie entsprechend an. Eigene Vorschläge zur Optimierung der Kampagne werden wie selbstverständlich vorgeschlagen. Eine Zusammenarbeit empfehle ich vorbehaltslos.'
    },
    {
      name: 'Elmar Rastner',
      position: 'Head of Key Account Management Europe',
      company: 'Swisspacer, Saint-Gobain',
      text: 'Ich glaube es ist im Vertrieb fundamental, auch über soziale Netzwerke neue Kunden zu suchen. Der Workshop mit Patrick Häfner war excellent. Wir haben gemeinsam mein LinkedIn Profil optimiert und er hat mir genau erklärt wie man erfolgreich die richtigen Kunden online findet und akquiriert. Der Workshop macht Spaß!'
    }
  ]
};
